import { render, staticRenderFns } from "./bestcomboprematch.vue?vue&type=template&id=7e199f4e&scoped=true&"
import script from "./bestcomboprematch.vue?vue&type=script&lang=js&"
export * from "./bestcomboprematch.vue?vue&type=script&lang=js&"
import style0 from "./bestcomboprematch.vue?vue&type=style&index=0&id=7e199f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e199f4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
